module.exports = __webpack_public_path__ + "static/media/template6.d30145cc.png";